<template>
    <div class="relative w-full">
        <TagsInputRoot
            v-model="inputValue"
            :disabled="disabled"
            class="min-h-input flex w-full flex-wrap items-center gap-2 rounded-input border px-3 py-2 text-sm focus-within:border-focus focus-within:ring-0"
            :class="{
                'border-error': errorMessage,
                'border-muval-gray-4 hover:border-muval-gray-3': !errorMessage,
                'bg-white': !disabled,
                '!bg-muval-gray-5': disabled,
            }"
        >
            <TagsInputItem
                v-for="tag in inputValue"
                :key="tag"
                :value="tag"
                class="flex items-center"
            >
                <slot
                    name="tag"
                    :tag="tag"
                    :remove="() => removeTag(tag)"
                >
                    <div class="card flex items-center gap-1.5 rounded px-2 py-0.5 text-xs text-muval-gray-1">
                        <span
                            :style="{ backgroundColor: getColourFromText(tag) }"
                            class="size-1.5 rounded-full"
                        />
                        <TagsInputItemText />
                        <TagsInputItemDelete class="ml-1 cursor-pointer text-muval-gray-3 hover:text-muval-gray-1">
                            <SvgIcon
                                name="system-close"
                                class="-mx-1 size-3.5"
                            />
                        </TagsInputItemDelete>
                    </div>
                </slot>
            </TagsInputItem>
            <TagsInputInput
                :placeholder="inputValue?.length ? '' : placeholder"
                :disabled="disabled"
                class="flex-1 bg-transparent text-sm text-muval-gray-1 placeholder-gray-400 outline-none"
            />
        </TagsInputRoot>
        <div
            v-if="label"
            class="pointer-events-none absolute -top-2 left-2 z-1 line-clamp-1 text-xs text-gray-400"
            :class="{ 'text-error': errorMessage }"
        >
            <span class="z-1 bg-white px-1">{{ label }}</span>
        </div>
        <div
            v-if="errorMessage"
            class="pointer-events-none absolute -bottom-5 w-full truncate whitespace-nowrap text-xxs text-error"
        >
            <span>{{ errorMessage }}</span>
        </div>
    </div>
</template>

<script setup lang="ts">
import { TagsInputRoot, TagsInputItem, TagsInputItemText, TagsInputItemDelete, TagsInputInput } from 'reka-ui';
import { useField } from 'vee-validate';
import { idGen } from '@utilities/idGen';
import { getColourFromText } from '@utilities/colors';

const props = withDefaults(
    defineProps<{
        modelValue?: string[] | null;
        vid?: string;
        label?: string | null;
        placeholder?: string;
        disabled?: boolean;
    }>(),
    {
        modelValue: () => [],
        vid: () => idGen(6),
        label: null,
        placeholder: 'Add tags...',
        disabled: false,
    },
);

const { value: inputValue, errorMessage } = useField<string[]>(() => props.vid, undefined, {
    syncVModel: true,
});

function removeTag(tagToRemove: string) {
    if (inputValue.value) {
        inputValue.value = inputValue.value.filter((tag) => tag !== tagToRemove);
    }
}
</script>
